import styled from 'styled-components/native';
import FontAwesome from 'react-native-vector-icons/dist/FontAwesome';
import Feather from 'react-native-vector-icons/Feather';
import {RFPercentage, RFValue} from 'react-native-responsive-fontsize';
import { css } from 'styled-components/native';

interface Check {
  checked?: boolean;
}


export const Container = styled.View`
  position: absolute;
  z-index: 301;
  top: ${RFPercentage(50)}px;
  right: 12px;
`;

export const Title = styled.Text`
  color: ${({theme}) => theme.colors.text_dark};
  font-size: ${RFValue(12)}px;
  font-family: ${({theme}) => theme.fonts.semibold};
`;

export const IconDev = styled.TouchableOpacity`
  background: ${({theme}) => theme.colors.primary};

  width: ${RFValue(50)}px;
  height: ${RFValue(50)}px;

  shadow-color: #000;
  shadow-offset: 0px 4px;
  shadow-opacity: 0.2;
  shadow-radius: 8px;
  elevation: 5;

  border-radius: ${RFValue(25)}px;

  justify-content: center;
  align-items: center;
`;

export const Icon = styled(FontAwesome)`
  color: ${({theme}) => theme.colors.shape};
  font-size: ${RFValue(28)}px;
`;

export const ModalContainer = styled.View``;

export const Content = styled.View`
  background-color: ${({theme}) => theme.colors.background_secondary};
  padding: ${RFValue(16)}px;
  margin: 0 24px;
  overflow: hidden;
  border-radius: ${RFValue(12)}px;
`;

export const InputContainer = styled.View`
  margin-bottom: ${RFValue(12)}px;
  padding: ${RFValue(8)}px ${RFValue(12)}px;
  background-color: ${({theme}) => theme.colors.background_black};
  border-radius: ${RFValue(10)}px;

  shadow-color: #000;
  shadow-offset: 0px 4px;
  shadow-opacity: 0.1;
  shadow-radius: 8px;
  elevation: 5;
  justify-content: flex-start;
  align-items: center;

  flex-direction: row;
`;

export const InputContainerColumn = styled.View`
  flex:1;
`;

export const InputLabel = styled.Text`
  font-family: ${({theme}) => theme.fonts.semibold};
  color: ${({theme}) => theme.colors.text};
  text-transform: uppercase;
  font-size: ${RFValue(10)}px;
`;


export const ClearInputButton = styled.TouchableOpacity``;
export const ClearInputIcon = styled(Feather)`
  font-size: ${RFValue(14)}px;
  color:${({theme}) => theme.colors.text};
`;


export const Input = styled.TextInput`
  font-family: ${({theme}) => theme.fonts.regular};
  font-size: ${RFValue(12)}px;
  color: ${({theme}) => theme.colors.title};
  width: 100%;
`;

export const DefaultUrls = styled.View`
  flex-direction: row;
  margin-bottom: ${RFValue(12)}px;
  gap: ${RFValue(12)}px;
`;

export const UrlButton = styled.TouchableOpacity`
  padding: ${RFValue(6)}px ${RFValue(12)}px;
  background-color: ${({theme}) => theme.colors.background_black};
  border-radius: ${RFValue(6)}px;
  flex: 1;
  shadow-color: #000;
  shadow-offset: 0px 4px;
  shadow-opacity: 0.1;
  shadow-radius: 8px;
  elevation: 5;

  justify-content: center;
  align-items: center;
`;

export const UrlText = styled.Text`
  font-family: ${({theme}) => theme.fonts.semibold};
  color: ${({theme}) => theme.colors.title};
  text-transform: uppercase;
  font-size: ${RFValue(8.5)}px;
`;



export const TermCheckButton = styled.TouchableOpacity`
  flex-direction: row;
  align-items:center;
  gap: ${RFValue(6)}px;

  margin-bottom: ${RFValue(10)}px;
`;

export const TermContainerBox = styled.View`
  flex-direction: column;
`;

export const TermCheckIcon = styled(FontAwesome)<Check>`
  font-size: ${RFValue(24)}px;
  color: ${({theme}) => theme.colors.border};
  ${({checked, theme}) =>
    checked &&
    css`
      color: ${theme.colors.blue};
    `}
`;


export const Label = styled.Text`
  font-size: ${RFValue(12)}px;
  color: ${({theme}) => theme.colors.title};
  font-family: ${({theme}) => theme.fonts.medium};
`;
